import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Service } from "src/app/core/jsonapi/service";
import { CaseAgentFlowSession } from "../_types/case-agent-flow-session";

@Injectable({
    providedIn: 'root',
})
export class CaseAgentFlowSessionsService extends Service<CaseAgentFlowSession> {
    public override type = 'caseAgentFlowSessions';
    public override url = 'attendance/caseAgentFlowSessions';

    public getFlows(): Observable<any[]> {
        return this.http.get<any[]>(this.getAPIUrl() + '/flows');
    }

    public requestSession(caseId: string, flowId: string): Observable<CaseAgentFlowSession> {
        return this.http.post<CaseAgentFlowSession>(this.getAPIUrl() + '/request-session', { caseId, flowId });
    }
}
